<template>
  <section class="after-before-block">
    <div v-if="title" class="wrapper">
      <h2 class="text-subheader">{{ title }}</h2>
    </div>
    <ClientOnly>
      <div class="swiper-container">
        <Swiper
          class="after-before-block__slider"
          :modules="[Pagination, Navigation]"
          :pagination="{
            clickable: true,
          }"
          navigation
          no-swiping
          centered-slides
          :slides-per-view="1.3"
          :loop="items.length > 1"
          :space-between="16"
          :breakpoints="breakpoints"
          no-swiping-class="after-before-block__images"
        >
          <SwiperSlide v-for="(slide, index) in items" :key="`slide_after-before_${index}`">
            <div class="after-before-block__slide">
              <ImgComparisonSlider class="after-before-block__images">
                <UIPictureTag
                  slot="first"
                  is-visible
                  class="after-before-block__first"
                  :image-original="`${url}${slide.image1.source}`"
                  :image-seo="slide.image1Seo"
                  :image-webp="`${url}${slide.image1.webp}`"
                />
                <UIPictureTag
                  slot="second"
                  is-visible
                  :image-original="`${url}${slide.image2.source}`"
                  :image-seo="slide.image2Seo"
                  :image-webp="`${url}${slide.image2.webp}`"
                />
                <svg
                  slot="handle"
                  width="184"
                  height="24"
                  viewBox="0 0 184 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M39.7424 17.04V8.56H35.3584L35.2784 10.544C35.2464 11.2907 35.1984 12 35.1344 12.672C35.081 13.3333 34.9904 13.936 34.8624 14.48C34.745 15.024 34.5797 15.4773 34.3664 15.84C34.153 16.2027 33.8917 16.4427 33.5824 16.56L31.3424 16.24C31.7477 16.2613 32.0784 16.1227 32.3344 15.824C32.601 15.5253 32.809 15.1093 32.9584 14.576C33.1077 14.0427 33.2197 13.4187 33.2944 12.704C33.369 11.9787 33.4224 11.1947 33.4544 10.352L33.5824 6.8H41.7904V17.04H39.7424ZM30.9584 20.384L30.9744 16.24H43.4064V20.384H41.4864V18H32.8944V20.384H30.9584ZM48.8083 18.112C47.9336 18.112 47.1549 17.9253 46.4723 17.552C45.7896 17.168 45.2509 16.6453 44.8563 15.984C44.4616 15.3227 44.2643 14.5707 44.2643 13.728C44.2643 12.8747 44.4616 12.1227 44.8563 11.472C45.2509 10.8107 45.7896 10.2933 46.4723 9.92C47.1549 9.54667 47.9336 9.36 48.8083 9.36C49.6936 9.36 50.4776 9.54667 51.1603 9.92C51.8536 10.2933 52.3923 10.8053 52.7763 11.456C53.1709 12.1067 53.3683 12.864 53.3683 13.728C53.3683 14.5707 53.1709 15.3227 52.7763 15.984C52.3923 16.6453 51.8536 17.168 51.1603 17.552C50.4776 17.9253 49.6936 18.112 48.8083 18.112ZM48.8083 16.4C49.2989 16.4 49.7363 16.2933 50.1203 16.08C50.5043 15.8667 50.8029 15.5573 51.0163 15.152C51.2403 14.7467 51.3523 14.272 51.3523 13.728C51.3523 13.1733 51.2403 12.6987 51.0163 12.304C50.8029 11.8987 50.5043 11.5893 50.1203 11.376C49.7363 11.1627 49.3043 11.056 48.8243 11.056C48.3336 11.056 47.8963 11.1627 47.5123 11.376C47.1389 11.5893 46.8403 11.8987 46.6163 12.304C46.3923 12.6987 46.2803 13.1733 46.2803 13.728C46.2803 14.272 46.3923 14.7467 46.6163 15.152C46.8403 15.5573 47.1389 15.8667 47.5123 16.08C47.8963 16.2933 48.3283 16.4 48.8083 16.4Z"
                    fill="white"
                  />
                  <path
                    d="M68 12C68 5.37258 73.3726 0 80 0H92V24H80C73.3726 24 68 18.6274 68 12Z"
                    fill="#4F4F4F"
                  />
                  <path
                    d="M81.3337 14.6666L78.667 11.9999L81.3337 9.33325"
                    stroke="#F4F4F4"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M92 0H104C110.627 0 116 5.37258 116 12C116 18.6274 110.627 24 104 24H92V0Z"
                    fill="#4F4F4F"
                  />
                  <path
                    d="M102.667 9.33325L105.334 11.9999L102.667 14.6666"
                    stroke="#F4F4F4"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M132.006 18V6.8H141.91V18H139.862V8.048L140.342 8.56H133.574L134.054 8.048V18H132.006ZM148.652 18.112C147.777 18.112 146.999 17.9253 146.316 17.552C145.633 17.168 145.095 16.6453 144.7 15.984C144.305 15.3227 144.108 14.5707 144.108 13.728C144.108 12.8747 144.305 12.1227 144.7 11.472C145.095 10.8107 145.633 10.2933 146.316 9.92C146.999 9.54667 147.777 9.36 148.652 9.36C149.537 9.36 150.321 9.54667 151.004 9.92C151.697 10.2933 152.236 10.8053 152.62 11.456C153.015 12.1067 153.212 12.864 153.212 13.728C153.212 14.5707 153.015 15.3227 152.62 15.984C152.236 16.6453 151.697 17.168 151.004 17.552C150.321 17.9253 149.537 18.112 148.652 18.112ZM148.652 16.4C149.143 16.4 149.58 16.2933 149.964 16.08C150.348 15.8667 150.647 15.5573 150.86 15.152C151.084 14.7467 151.196 14.272 151.196 13.728C151.196 13.1733 151.084 12.6987 150.86 12.304C150.647 11.8987 150.348 11.5893 149.964 11.376C149.58 11.1627 149.148 11.056 148.668 11.056C148.177 11.056 147.74 11.1627 147.356 11.376C146.983 11.5893 146.684 11.8987 146.46 12.304C146.236 12.6987 146.124 13.1733 146.124 13.728C146.124 14.272 146.236 14.7467 146.46 15.152C146.684 15.5573 146.983 15.8667 147.356 16.08C147.74 16.2933 148.172 16.4 148.652 16.4ZM159.076 18.112C158.18 18.112 157.38 17.9253 156.676 17.552C155.982 17.168 155.438 16.6453 155.044 15.984C154.649 15.3227 154.452 14.5707 154.452 13.728C154.452 12.8747 154.649 12.1227 155.044 11.472C155.438 10.8107 155.982 10.2933 156.676 9.92C157.38 9.54667 158.18 9.36 159.076 9.36C159.908 9.36 160.638 9.53067 161.268 9.872C161.908 10.2027 162.393 10.6933 162.724 11.344L161.188 12.24C160.932 11.8347 160.617 11.536 160.244 11.344C159.881 11.152 159.486 11.056 159.06 11.056C158.569 11.056 158.126 11.1627 157.732 11.376C157.337 11.5893 157.028 11.8987 156.804 12.304C156.58 12.6987 156.468 13.1733 156.468 13.728C156.468 14.2827 156.58 14.7627 156.804 15.168C157.028 15.5627 157.337 15.8667 157.732 16.08C158.126 16.2933 158.569 16.4 159.06 16.4C159.486 16.4 159.881 16.304 160.244 16.112C160.617 15.92 160.932 15.6213 161.188 15.216L162.724 16.112C162.393 16.752 161.908 17.248 161.268 17.6C160.638 17.9413 159.908 18.112 159.076 18.112ZM163.049 17.984L163.145 16.304C163.22 16.3147 163.289 16.3253 163.353 16.336C163.417 16.3467 163.476 16.352 163.529 16.352C163.86 16.352 164.116 16.2507 164.297 16.048C164.478 15.8453 164.612 15.5733 164.697 15.232C164.793 14.88 164.857 14.4907 164.889 14.064C164.932 13.6267 164.964 13.1893 164.985 12.752L165.129 9.456H172.041V18H170.041V10.608L170.505 11.152H166.441L166.873 10.592L166.761 12.848C166.729 13.6053 166.665 14.3093 166.569 14.96C166.484 15.6 166.345 16.16 166.153 16.64C165.972 17.12 165.716 17.4933 165.385 17.76C165.065 18.0267 164.654 18.16 164.153 18.16C163.993 18.16 163.817 18.144 163.625 18.112C163.444 18.08 163.252 18.0373 163.049 17.984ZM178.719 18.112C177.769 18.112 176.937 17.9253 176.223 17.552C175.519 17.168 174.969 16.6453 174.575 15.984C174.191 15.3227 173.999 14.5707 173.999 13.728C173.999 12.8747 174.185 12.1227 174.559 11.472C174.943 10.8107 175.465 10.2933 176.127 9.92C176.799 9.54667 177.561 9.36 178.415 9.36C179.247 9.36 179.988 9.54133 180.639 9.904C181.289 10.2667 181.801 10.7787 182.175 11.44C182.548 12.1013 182.735 12.88 182.735 13.776C182.735 13.8613 182.729 13.9573 182.719 14.064C182.719 14.1707 182.713 14.272 182.703 14.368H175.583V13.04H181.647L180.863 13.456C180.873 12.9653 180.772 12.5333 180.559 12.16C180.345 11.7867 180.052 11.4933 179.679 11.28C179.316 11.0667 178.895 10.96 178.415 10.96C177.924 10.96 177.492 11.0667 177.119 11.28C176.756 11.4933 176.468 11.792 176.255 12.176C176.052 12.5493 175.951 12.992 175.951 13.504V13.824C175.951 14.336 176.068 14.7893 176.303 15.184C176.537 15.5787 176.868 15.8827 177.295 16.096C177.721 16.3093 178.212 16.416 178.767 16.416C179.247 16.416 179.679 16.3413 180.063 16.192C180.447 16.0427 180.788 15.808 181.087 15.488L182.159 16.72C181.775 17.168 181.289 17.5147 180.703 17.76C180.127 17.9947 179.465 18.112 178.719 18.112Z"
                    fill="white"
                  />
                </svg>
              </ImgComparisonSlider>
              <CollapseText :slide="slide" />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </ClientOnly>
  </section>
</template>

<script setup lang="ts">
import 'swiper/css';
import { Pagination, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { ImgComparisonSlider } from '@img-comparison-slider/vue';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import type { ImageItem, ImageSEO } from '~/types/pages';
import { useRuntimeConfig } from '#imports';
import './styles.scss';
import CollapseText from '~/components/blocks/afterBeforeSlider/CollapseText.vue';

interface Props {
  title: string;
  items: {
    image1: ImageItem;
    image2: ImageItem;
    image1Seo: ImageSEO;
    image2Seo: ImageSEO;
    description: string;
  }[];
}

defineProps<Props>();
const url = useRuntimeConfig().public.siteUrl;

const breakpoints = {
  520: {
    slidesPerView: 2,
    spaceBetween: 24,
  },
  768: {
    slidesPerView: 3.2,
    spaceBetween: 64,
  },
};
</script>

<style scoped></style>
